import React from 'react';
import keyBy from 'lodash/keyBy';
import { WhiteSection } from 'components/base/layout-components';
import {
  getFormattedAndCalculatedV3Data,
  getMappedData
} from '../groupDashboard.service';
import useSettingsService from 'components/hooks/useSettingsService';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import {
  getWidgetsTitlesInitialState,
  handleEditMetricsClick,
  getTrendLineDataMappedPerMericName
} from './GroupMetricsWidget.service';
import GroupMetricsWidgetNew from './GroupMetricsWidgetNew';
import { useSelector } from 'react-redux';
import { getGranularityByDates } from '../../../performance/views/CustomReport/custom-report.util';
import { GRANULARITY } from '../../../performance/views/CustomReport/consts';
import { dateRangeSelector } from 'state/selectors/ui-state';

const GroupMetricsWidgets = ({
  metrics,
  selectedGroup,
  widgetsMetricsNames,
  metricsWidgetWidth,
  toggleModal,
  availableMetricsWidgets,
  setWidgetsMetricsNames,
  metricsLoading,
  isWidgetsSettingValue,
  metricsPerGranularity,
  metricsPerGranularityLoading,
  minMetricsToSelect,
  maxMetricsToSelect,
  modalInstructions
}) => {
  const selectedGroupId = selectedGroup?.[0]?.id;
  const { mappedV3Data, metricsPerGranularityMapped } = getMappedData(
    metrics,
    metricsPerGranularity,
    selectedGroupId
  );

  const { formattedV3Data, V3DataCalculated } = getFormattedAndCalculatedV3Data(
    mappedV3Data,
    widgetsMetricsNames,
    availableMetricsWidgets,
    metricsPerGranularityMapped
  );

  const widgetsTitlesInitialStateModal = getWidgetsTitlesInitialState(
    availableMetricsWidgets,
    widgetsMetricsNames
  );

  const { getSettingOrDefinitionValue, updateSetting } = useSettingsService();
  const isCustomizeMetrics = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.groupDashboardMetricsCustomizeEnabled
  });
  const metricsWidgetsByName = keyBy(
    availableMetricsWidgets,
    'metrics[0].name'
  );

  const isWidgetLoading =
    !availableMetricsWidgets.length ||
    metricsLoading ||
    !isWidgetsSettingValue ||
    metricsPerGranularityLoading;

  const dates = useSelector(dateRangeSelector);
  const granularity = getGranularityByDates({
    start_date: dates.from,
    end_date: dates.to,
    selectedGranularity: GRANULARITY.AUTO
  });

  return (
    <>
      {widgetsMetricsNames.map((widgetMetricName, i) => (
        <WhiteSection
          borderRadius='0.45rem'
          height='22rem'
          width={metricsWidgetWidth}
          mb='0.75rem'
          ml='0.75rem'
          key={widgetMetricName}
          data-testid='metrics-widgets'
        >
          <GroupMetricsWidgetNew
            isWidgetLoading={isWidgetLoading}
            widgetMetricName={widgetMetricName}
            widgetMetricValue={V3DataCalculated[widgetMetricName]}
            displayValueText={formattedV3Data[widgetMetricName]}
            selectedGroupId={selectedGroupId}
            isCustomizeMetrics={isCustomizeMetrics}
            availableMetricsWidget={metricsWidgetsByName[widgetMetricName]}
            onClick={() =>
              handleEditMetricsClick(
                toggleModal,
                availableMetricsWidgets,
                setWidgetsMetricsNames,
                widgetsTitlesInitialStateModal,
                updateSetting,
                selectedGroupId,
                minMetricsToSelect,
                maxMetricsToSelect,
                modalInstructions
              )
            }
            trendLineData={getTrendLineDataMappedPerMericName(
              widgetMetricName,
              metricsPerGranularityMapped,
              availableMetricsWidgets
            )}
            granularity={granularity}
          />
        </WhiteSection>
      ))}
    </>
  );
};

export default GroupMetricsWidgets;
